<template>
  <div class="d-flex">
    <div class="rounded bg-primary w-25 mr-1 ml-1" :class="[(percent === 100 ? 'bg-success' : (percent >= 51 ? 'bg-warning' : (percent >= 26 ? 'bg-warning' : (percent >= 1 ? 'bg-danger' : 'bg-secondary'))))]" style="height: 10px"></div>
    <div class="rounded bg-primary w-25 mr-1 ml-1" :class="[(percent === 100 ? 'bg-success' : (percent >= 51 ? 'bg-warning' : (percent >= 26 ? 'bg-warning' : (percent >= 1 ? 'bg-secondary' : 'bg-secondary'))))]" style="height: 10px"></div>
    <div class="rounded bg-primary w-25 mr-1 ml-1" :class="[(percent === 100 ? 'bg-success' : (percent >= 51 ? 'bg-warning' : (percent >= 26 ? 'bg-secondary' : (percent >= 1 ? 'bg-secondary' : 'bg-secondary'))))]" style="height: 10px"></div>
    <div class="rounded bg-primary w-25 mr-1 ml-1" :class="[(percent === 100 ? 'bg-success' : (percent >= 51 ? 'bg-secondary' : (percent >= 26 ? 'bg-secondary' : (percent >= 1 ? 'bg-secondary' : 'bg-secondary'))))]" style="height: 10px"></div>
  </div>
</template>

<script >

export default {
  props: {
    percent:0,
  },
  components: {
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";
</style>
